import { render, staticRenderFns } from "./product-details.vue?vue&type=template&id=26b9ab9d&scoped=true&"
import script from "./product-details.vue?vue&type=script&lang=js&"
export * from "./product-details.vue?vue&type=script&lang=js&"
import style0 from "./product-details.vue?vue&type=style&index=0&id=26b9ab9d&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26b9ab9d",
  null
  
)

export default component.exports